import axios from "axios";
import * as types from "../mutation-types";
import api from "../../api/api";

// state
export const state = {
  pagination: {
    from: 0,
    to: 0,
    totalPage: 0,
    path: "",
    currentPage: 0,
    totalRecord: 0,
    perPage: 0
  },
  newList: [],
  categories: [],
  newDetail: {}
}

// getters
export const getters = {
  newList: state => state.newList,
  categories: state => state.categories,
  pagination: state => state.pagination,
  newDetail: state => state.newDetail,
}

// mutations
export const mutations = {
  [types.NEW.NEW_LIST](state, newList) {
    state.newList = newList.news;
    state.pagination.from = newList.news.from;
    state.pagination.to = newList.news.to;
    state.pagination.totalPage = newList.news.last_page;
    state.pagination.path = newList.news.path;
    state.pagination.currentPage = newList.news.current_page;
    state.pagination.totalRecord = newList.news.total;
    state.pagination.perPage = newList.news.per_page;
    state.categories = newList.category
  },
  [types.NEW.NEW_DETAIL](state, newDetail) {
    state.newDetail = newDetail.news;
    state.categories = newDetail.category
  }
}

// actions
export const actions = {
  // eslint-disable-next-line
  async createNews(_, params) {
    await axios.post(api.NEWS.NEW_POST, params);
  },

  async updateNews(_, params) {
    let url = `${api.NEWS.NEW_UPDATE}/${params.get("id")}`;
    await axios.post(url, params);
  },

  async deleteNews(_, params) {
    let url = `${api.NEWS.NEW_DELETE}/${params}`;
    await axios.delete(url, params);
  },

  async fetchListNew({
    commit
  }, payload) {
    const response = await axios.get(api.NEWS.NEW_LIST, {
      params: {
        page: payload.currentPage,
        category: payload.category
      }
    });

    commit(
      types.NEW.NEW_LIST,
      response.data
    );
  },

  async fetchNewDetail({
    commit
  }, payload) {
    const response = await axios.get(`${api.NEWS.NEW_EDIT}/${payload}`);

    commit(
      types.NEW.NEW_DETAIL,
      response.data
    );
  },
}
